import {
    GENERIC_DATA_FORM_LOADING,
    GENERIC_DATA_FORM_RECEIVE,
    GENERIC_DATA_FORM_ERROR,
    GENERIC_DATA_FORM_SUBMITBUTTON,
    GENERIC_DATA_VIEW_CHANGES_MADE_MODAL,
    GENERIC_DATA_VIEW_CHANGES_MADE,
    GENERIC_DATA_VIEW_STATUS_SENDING_ALL_FORMS,
    GENERIC_DATA_VIEW_CLEAR_ALL_DIRTY_FIELDS,
    GENERIC_DATA_VIEW_UPDATE_DIRTY_FIELDS,
    GENERIC_MODAL_DATA_VIEW_UPDATE_DIRTY_FIELDS,
    GENERIC_DATA_FORM_SAVE_UPDATING_CONTAINER_DATA, // Import the new action type
} from '../constants';

import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    allFormsDirtyFields: [],
    allFormsModalDirtyFields: [],
    changesMade: [],
    changesMadeModal: [],
    dataContainers: [],
    errors: {},
    isLoading: false,
    btnIsActive: false,
    updatingContainerData: {}, // New variable to store updating container data
};

export const genericDataForm = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GENERIC_DATA_VIEW_CHANGES_MADE:
        case GENERIC_DATA_VIEW_CHANGES_MADE_MODAL:
        case GENERIC_DATA_VIEW_STATUS_SENDING_ALL_FORMS:
        case GENERIC_DATA_VIEW_CLEAR_ALL_DIRTY_FIELDS:
            return {
                ...state,
                ...payload,
            };
        case GENERIC_DATA_FORM_LOADING:
            return {
                ...state,
                errors: {},
                isLoading: true,
            };
        case GENERIC_DATA_FORM_SUBMITBUTTON:
        case GENERIC_DATA_FORM_RECEIVE:
            return {
                ...state,
                errors: {},
                isLoading: false,
                ...payload,
            };
        case GENERIC_DATA_FORM_ERROR:
            return {
                ...state,
                isLoading: false,
                errors: errorReducer(state.errors, action),
            };
        case GENERIC_MODAL_DATA_VIEW_UPDATE_DIRTY_FIELDS:
            let foundModalIdentifier = false;
            const identifierModal = payload.allFormsModalDirtyFields.entitySystemId;

            const newModalDirtyFields = state.allFormsModalDirtyFields.map((container) => {
                if (container.entitySystemId == identifierModal) {
                    return payload.allFormsModalDirtyFields;
                }
                return container;
            });
            if (!state.allFormsModalDirtyFields) {
                newModalDirtyFields.push(payload.allFormsModalDirtyFields);
            }
            return {
                ...state,
                allFormsModalDirtyFields: newModalDirtyFields,
            };
        case GENERIC_DATA_VIEW_UPDATE_DIRTY_FIELDS:
            const identifier = payload.allFormsDirtyFields.entitySystemId;
            let foundIdentifier = false;

            const newDirtyFields = state.allFormsDirtyFields.map((container) => {
                if (container.entitySystemId == identifier) {
                    foundIdentifier = true;
                    return { ...payload.allFormsDirtyFields };
                }
                return { ...container };
            });
            if (!foundIdentifier) {
                newDirtyFields.push(payload.allFormsDirtyFields);
            }
            return { ...state, allFormsDirtyFields: newDirtyFields };
        case GENERIC_DATA_FORM_SAVE_UPDATING_CONTAINER_DATA: // Handle the new action type
            return {
                ...state,
                updatingContainerData: {
                    ...state.updatingContainerData,
                    [payload.entitySystemId]: payload.data,
                },
            };
        default:
            return state;
    }
};
